
import { defineComponent } from 'vue'
import VehicleWithdrawalTable from '@/components/vehicle-withdrawal/VehicleWithdrawalTable.vue'

export default defineComponent({
  name: 'VehicleWithdrawal',

  components: {
    VehicleWithdrawalTable,
  },

  setup() {
    return {}
  },
})
